<template>
  <div class="error">
    <h1>Page Not Found</h1>
    <p>Error404</p>
    <neo-button @click="$router.push('/')">Go Home</neo-button>
  </div>
</template>

<script>
import NeoButton from "@/components/Base/NeoButton.vue";

export default {
  name: "Error",
  components: { NeoButton },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.error {
  height: 100vh;
  width: 100%;
  background-image: url("/neo-bg.png");
  background-size: cover;
  background-position: center center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  h1 {
    font-size: 5rem;
  }

  p {
    font-size: 1.5rem;
    margin-bottom: 40px;
  }
}
</style>
